import React from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import { withTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

class TableClientList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNameAsc: true,
      isPhoneAsc: true,
      isBookingsAsc: true,
      isRevenueAsc: true,
    };
  }

  render() {
    const { clients, wholeList, sortFunction, campaignId, t } = this.props;

    return (
      <table className="tbl-clients-list fixed-header">
        <thead>
          <tr>
            <th className="text-left cell-cl-name">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortFunction('user_name', this.state.isNameAsc, campaignId);
                  this.setState({ isNameAsc: !this.state.isNameAsc });
                }}
                className="sort-btn "
              >
                {t('campaigns.tableRows.clientName')}
                <div className="client-info-icon">
                  <span className="tooltip">
                    <div className="tooltip-centered">{t('campaigns.tableClientList.clientNameTooltipText')}</div>
                  </span>
                </div>
              </span>
            </th>
            <th style={{ width: '180px' }} className="text-left">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortFunction('phone', this.state.isPhoneAsc, campaignId);
                  this.setState({ isPhoneAsc: !this.state.isPhoneAsc });
                }}
                className="sort-btn"
              >
                {t('campaigns.tableRows.mobile')}
              </span>
            </th>
            {fromAnyToBool(wholeList) && (
              <th style={{ width: '130px' }}>
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('appointments_count', this.state.isBookingsAsc, campaignId);
                    this.setState({ isBookingsAsc: !this.state.isBookingsAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableClientList.bookings')}
                </span>
              </th>
            )}
            {fromAnyToBool(wholeList) && (
              <th style={{ width: '160px' }}>
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('revenue', this.state.isRevenueAsc, campaignId);
                    this.setState({ isRevenueAsc: !this.state.isRevenueAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableClientList.bookingValue')}
                </span>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <tr key={clients.indexOf(client)}>
              <td style={{ width: '200px' }} className="text-left">
                {client.user_name}
              </td>
              <td style={{ width: '180px' }} className="text-left">
                {client.phone}
              </td>
              {fromAnyToBool(wholeList) && <td style={{ width: '130px' }}>{client.appointments_count}</td>}
              {fromAnyToBool(wholeList) && (
                <td style={{ width: '160px' }}>
                  {client.revenue ? (
                    <>
                      <CurrencySign />
                      {client.revenue}
                    </>
                  ) : (
                    '-'
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

const TableClientListHoc = withTranslation()(TableClientList);
export default TableClientListHoc;
